import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const languagesMustDifferValidator: ValidatorFn = (group: AbstractControl): ValidationErrors | null => {
  const from = group.get('languageFrom')?.value;
  const to = group.get('languageTo')?.value;

  if (from == null || to == null) return null;
  return String(from) === String(to) ? { sameLanguageSelected: true } : null;
};